import { apiCaller } from "../helper";

export const fetchStateDropdownValue = async (setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "STATE_DDC",
    primaryKey: {},
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching blocks data");
  }
};
export const fetchDistDropdownValue = async (setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "DISTRICT_DDC",
    primaryKey: {},
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching blocks data");
  }
};
export const fetchUnionDropdownValue = async (setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "UNION_DDC",
    primaryKey: {},
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching blocks data");
  }
};

export const fetchBlockDropdownValue = async (districtCode, setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "BLOCK_DDC",
    primaryKey: {
      districtId: districtCode,
    },
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching blocks data");
  }
};

//   utility function to set block the dropdown value
export const fetchPanchayatDropdownValue = async (blockCode, setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "GP_DDC",
    primaryKey: {
      blockId: blockCode,
    },
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching Panchayat dropdown data");
  }
};
//   utility function to set block the dropdown value
export const fetchPanchayatWiseVillageDropdownValue = async (
  panchayatCode,
  setValue
) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "VILLAGE_GP_DDC",
    primaryKey: {
      gpId: panchayatCode,
    },
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching Panchayat dropdown data");
  }
};
//   utility function to set block the dropdown value
export const fetchVillageDropdownValue = async (
  distCode,
  blockCode,
  setValue
) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "VILLAGE_DDC",
    primaryKey: {
      districtId: distCode,
      blockId: blockCode,
    },
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching village dropdown data");
  }
};
//   utility function to set block the dropdown value
export const fetchPlantDropdownValue = async (unionCode, setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "PLANT_DDC",
    primaryKey: {
      unionId: unionCode,
    },
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching plant dropdown data");
  }
};
export const fetchAllPlantDropdownValue = async (setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "PLANT_ALL_DDC",
    primaryKey: {},
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching plant dropdown data");
  }
};

//   utility function to set bmc  dropdown value
export const fetchBmcDropdownValue = async (plantCode, setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "BMC_DDC",
    primaryKey: {
      plantId: plantCode,
    },
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching plant dropdown data");
  }
};
export const fetchDcsDropdownValue = async (unionCode, setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "DCS_FULL_DDC",
    primaryKey: {
      unionId: unionCode,
    },
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      const formattedData = data?.map((item) => ({
        ...item,
        // item.code (Internal Code) is the value sent to APIs
        // dcsCode is the dcs legacy code shown in the dropdown label for user visibility.
        desc: item.dcsCode ? `${item.dcsCode} - ${item.desc}` : `${item.code} - ${item.desc}`,
      }));
      setValue(formattedData);
    }
  } catch (error) {
    console.log("Error while fetching DCS dropdown data");
    console.log(error);
  }
};

// Utility function to fetch user group dropdown values
export const fetchUserGroupDropdownValue = async (setValue) => {
  const url = "/dropdown";
  const dataToSend = {
    dropdownCode: "USER_GROUP_DDC",
    primaryKey: {},
  };
  try {
    const { data } = await apiCaller(url, "POST", dataToSend);
    if (data) {
      setValue(data);
    }
  } catch (error) {
    console.log("Error while fetching user group dropdown data");
    console.log(error);
  }
};
